import { Injectable } from "@angular/core";
import { Data } from "@angular/router";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { CaptchaService } from "@core/captcha.service";
import { UtilityService } from "@core/utility.service";
import { PaymentService } from "src/app/services/payment.service";
import { RequestUserService } from "src/app/services/RequestBodyService/RequestUser/request-user.service";
import { TokenService } from "src/app/services/token.service";
import { UserManagementService } from "src/app/services/user-management.service";

@Injectable({
  providedIn: "root",
})
export class PartialRegistrationService {
  constructor(
    private AuthPartialRegService: AuthPartialRegService,
    private utilityService: UtilityService,
    private userManagementService: UserManagementService,
    private paymentService: PaymentService,
    private captchaService: CaptchaService,
    private requestService: RequestUserService,
    private tokenService: TokenService
  ) {}

  setValues(value: string, nodeValue: string) {
    if (value) {
      localStorage.setItem(nodeValue, value);
      this.AuthPartialRegService.setCookie(nodeValue, value, 1);
    } else if (localStorage.getItem(nodeValue)) {
      value = localStorage.getItem(nodeValue);
      localStorage.setItem(nodeValue, value);
      this.AuthPartialRegService.setCookie(nodeValue, value, 1);
      return value;
    } else if (this.utilityService.getCookie(nodeValue)) {
      value = this.utilityService.getCookie(nodeValue);
      localStorage.setItem(nodeValue, value);
      this.AuthPartialRegService.setCookie(nodeValue, value, 1);
    } else {
      value = "";
    }

    return value;
  }

  getSelectedLanguage(languageArray: Data, selectedLanguage: string) {
    const result = languageArray.map((item) => {
      if (item.language_code === selectedLanguage) {
        item.selected = true;
      } else {
        item.selected = false;
      }
      return item;
    });

    const english = result.filter((item) => item.language_code === "en");
    const rest = result.filter((item) => item.language_code !== "en");
    return [...english, ...rest];
  }

  getSelectedCurrency(currencyArray: Data, selectedCurrency: string) {
    const result = currencyArray.map((item) => {
      if (item.currency_code === selectedCurrency) {
        item.selected = true;
      } else {
        item.selected = false;
      }
      return item;
    });

    const gbp = result.filter((item) => item.currency_code === "GBP");
    const rest = result.filter((item) => item.currency_code !== "GBP");
    return [...gbp, ...rest];
  }

  getLanguageList() {
    return this.utilityService.getLanguageList();
  }

  otpSent() {
    this.captchaService.otpSent$.next(false);
  }

  setPreferredCurrency(prosubIntPrice: Data, prosubPrice: number) {
    let currency = this.userManagementService.selectedCurrency;
    this.paymentService.preferredCurrencyObj = {
      amount: String(
        prosubIntPrice?.[currency] ? prosubIntPrice?.[currency]?.toFixed(2) : prosubPrice ? prosubPrice?.toFixed(2) : 0
      ),
      currency: currency,
    };
  }

  getSocialPassword() {
    return this.requestService.socialPassword();
  }

  getUserId() {
    return this.tokenService.getUserId();
  }

  storeUserID(userId: string) {
    this.tokenService.securelyStoreUserId(userId);
    this.tokenService.getUserId();
  }

  getUserUpdate() {
    return this.userManagementService.userRequest$;
  }
}
